import FilipsFunction from './FilipsFunction';
import sampleFunction from './sampleFunction';

import myNewFunction from './myNewFunction';
import setAnnotationCount from './SetAnnotationCount';
import massArchive from './MassArchiveBinders';
import massDelete from './MassDeleteBinders';
import createNewProcessForOrganization from './CreateNewProcessForOrganization';

export const listOfBatchOperations = [
  {
    ...sampleFunction
  },
  {
    ...FilipsFunction
  },
  {
    ...myNewFunction
  },
  {
    ...setAnnotationCount
  },
  {
    ...massArchive
  },
  {
    ...massDelete
  },
  { ...createNewProcessForOrganization }
];
